<template>
  <div class=''>
    <canvas id="pdf-canvas"></canvas>
  </div>
</template>

<script>
import PDFJS from 'pdfjs-dist'
export default {
  props: {
    src: {
      type: String,
      require: true
    },
    page: {
      type: Number,
      default: 1
    },
    scale: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      pdfData: '',
      pdfText: {
        items: []
      },
      currentPage: 1,
      isFullScreen: false,
      fileName: '',
      isUrlInputShow: false
    };
  },
  watch: {
    page (newValue) {
      this.renderPdf(newValue)
    },
  },
  mounted () {
    if (this.src) {
      this.getPDF()
    }
  },
  methods: {
    async getPDF () {
      try {
        let pdf = await PDFJS.getDocument(this.src)
        this.pdfData = pdf
        this.$emit('loaded')
        this.$emit('num-pages', pdf.numPages)
        this.renderPdf(1)
      } catch (error) {
        this.$emit('error')
      }

    },
    async renderPdf (num, scale = this.scale) {
      try {
        const page = await this.pdfData.getPage(num)

        const viewport = page.getViewport(scale)
        const container = this.$refs.container
        const canvas = document.getElementById('pdf-canvas')
        const context = canvas.getContext('2d')
        canvas.setAttribute('style', `width: 100%`)

        canvas.height = viewport.height
        canvas.width = viewport.width

        const renderContext = {
          canvasContext: context,
          viewport
        }

        page.render(renderContext)
        this.$emit('progress', 1)
        // this.renderText(page, viewport, pageDiv)
      } catch (e) {
        console.error('Pdf Render Error::', e)
      }
    },
    async renderText (page, viewport, pageDiv) {
      try {
        const textContent = await page.getTextContent()
        const textLayerDiv = document.createElement('div')

        this.pdfText.items = this.pdfText.items.concat(textContent.items)

        // 用于文字层与canvas层文字对齐
        textLayerDiv.setAttribute('class', 'textLayer')
        textLayerDiv.setAttribute(
          'style',
          `width: ${viewport.width}px; margin: 0 auto; margin-top: 50px`
        )

        const textLayer = new TextLayerBuilder({
          textLayerDiv: textLayerDiv,
          pageIndex: page.pageIndex,
          viewport
        })

        textLayer.setTextContent(textContent)
        textLayer.render()
        pageDiv.appendChild(textLayerDiv)
      } catch (e) {
        console.error('Text Render Error::', e)
      }
    },
  },
}
</script>